export default __webpack_public_path__ + "static/media/lsvtools.c048e48c.png";